import 'react-slidedown/lib/slidedown.css';
import * as React from 'react';
import classnames from 'classnames';
import Packages from './Packages';
import { useCallback, useState } from 'react';
import { VenueProfileContext } from '../../context';
import { Venues } from '@weddingspot/ws-api-client';
import styles from './Packages.module.scss';
const SlideDown = require('react-slidedown').SlideDown;

const PackagesWrapper = () => {
    const [isShown, setIsShown] = useState<boolean>(false);
    const handleToggleClick = useCallback(() => {
        setIsShown((value) => !value);
    }, []);
    const context = React.useContext(VenueProfileContext);

    const wsVenueProfile = React.useMemo(() => context.wsVenueProfile, []) as Venues.VenueDetails;

    if (wsVenueProfile.packages.length <= 0) {
        return null;
    }

    return (
        <div className={styles.detail}>
            <div className={styles.detailHeadlineContainer} onClick={handleToggleClick}>
                <h2 className={styles.detailHeadline}>
                    Packages
                    <i className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': isShown })} />
                </h2>
            </div>
            <SlideDown>
                {isShown && (
                    <>
                        <Packages packages={wsVenueProfile.packages} />
                    </>
                )}
            </SlideDown>
        </div>
    );
};

export default PackagesWrapper;
